import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const AugustoPostFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._16};
  width: 100%;
  height: 100%;

  #footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${SPACING._8};
  }
`;

export const FilePickerContainer = styled.div``;
